import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { Dropdown, Modal } from 'react-bootstrap'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'
import _ from 'lodash'

import { geotabAuthentication } from '../../helpers/helperGeotab'
import { isInternalUser, timezoneDBOptions } from '../../helpers/constants'
import { getCompanyById, updateCompany, deleteCompany, getCompaniesList, disableCompany, sendGeotabLink } from '../../../action/CompaniesActions'
import { getCompanyGeotabData, deleteGeotabCompany } from '../../../action/GeotabActions'
import { errorDetection } from '../../helpers/helperErrors'
import { redirectToRoscoLive } from '../../helpers/helperRedirect'

import '../../dump/menuComponents/menuComponents.sass'
import GreyHeader from '../../../component/dump/menuComponents/GreyHeader'
import CustomButton from '../../CustomButton';
import { CustomButtonToggle } from '../../DropdownComponents'

const CompanyEditContainer = (props) => {
	// console.log('PROPS CompanyEditContainer: ', props)
	const { location, user, toggleLoader } = props
	const userRole = user.roles[0]

	const [trialAvailableUsers, setTrialAvailableUsers] = useState([])
	const [data, setData] = useState({
		data_limit: '',
		billing_date: '',
		partner_company: '',
		driver_recognition: 'manual'
	})
	const [modal, setModal] = useState({
		show: false,
		content: '',
		error: false
	})
	const [errMessage, setErrMessage] = useState({
		company_name: '',
		company_city: '',
		company_state: '',
		company_zipcode: '',
		company_address: '',
		company_country: '',
		billing_date: '',
		active: '',
		partner_company: '',
		company_type: '',
		user_login: '',
		user_password: '',
		fleet_token_r1: '',
		data_limit: '',
		geotab_email: '',
	})
	const [company, setCompany] = useState({})
	const [geotab_creds, setGeotab_creds] = useState({
		email: '',
		password: ''
	})
	const [showGeotabPassword, setShowGeotabPassword] = useState(false)
	const [upd, setUpd] = useState(false)
	const initialCompany = location.state.company
	const readOnly = location.state.readOnly // FWSD-5986

	useEffect(() => {
		getCompany(initialCompany.id);
	}, [])

	const getCompany = (argCompanyId, callback) => {
		if (location) {
			toggleLoader(true);
			getCompanyById(userRole, argCompanyId)
				.then((res, err) => {
					if (res.status === 200) {
						toggleLoader(false);
						const secondObject = {};
						for (var k in res.data.response.company) {
							secondObject[k] = res.data.response.company[k];
						}
						const newElement = res.data.response.company;
						setCompany(secondObject)
						setData(newElement)
						if (newElement.geotab_database) {
							let data = {
								company_name: newElement.company_name,
								partner_name: newElement.partner_company,
								user_role: userRole,
								company_id: newElement.id,
							}
							getCompanyGeotabData(data)
								.then(res => {
									setGeotab_creds(res.data.response)
								})
								.catch(err => {
									console.log(err)
								})
						}

						if (newElement.trial_subscribers) {
							const resUsers = newElement.trial_subscribers.split(',').map(item => ({ value: item, label: item }))
							setTrialAvailableUsers(_.uniqBy([...trialAvailableUsers, ...resUsers], 'value'));
						}

						if (callback && typeof callback === 'function') {
							callback()
						}
					}
					if (err) {
						toggleLoader(false);
					}
				})
				.catch((error) => {
					toggleLoader(false);
				});
		}
	}

	const cancelCompanyUpdates = () => {
		browserHistory.push('/company')
	}

	const changeData = () => {
		const changedData = _.reduce(_.keys(data), (result, key) => {
			if (!Object.prototype.hasOwnProperty.call(company, key) || !_.isEqual(company[key], data[key])) {
				result[key] = data[key]
			}
			return result;
		}, {});
		delete changedData.geotab_email;
		delete changedData.show_provisionlink;
		delete changedData.geotab_provider;

		return changedData
	}

	const saveCompanyUpdates = (e) => {
		const { addCompany, delCompany, editCompany, editCompanyCollection } = props;

		const changedData = changeData();

		if (_.isEmpty(changedData)) {
			toastr.warning('', 'This company has no changes')
			return
		}

		const sendData = {
			company,
			data: changedData,
		}

		const error = checkForm(changedData)
		if (!error) {
			toggleLoader(true)

			updateCompany(sendData, userRole)
				.then((res, err) => {
					const newData = res.data.response.company

					if (data.partner_company !== company.partner_company) {
						if (props.company.partner === data.partner_company) {
							addCompany({ company: data.company_name });
						} else if (props.company.partner !== data.partner_company) {
							delCompany({ company: data.company_name });
						}
					}

					setCompany(newData);

					if (company.active !== data.active) {
						let active;
						if (data.active) {
							active = 'enable';
						} else {
							active = 'disable'
						}

						disableCompany(userRole, sendData, active)
							.then((res1, err1) => {
								toggleLoader(false);
							})
							.catch((error1) => {
								toggleLoader(false);

								toastr.error('An unexpected error occurred. Please try again later');
							});
					}

					// updates company state of the company reducer and company_collection state of the partnerList reducer if changed the driver_recognition value
					if (_.has(changedData, 'driver_recognition')) {
						if (props.company.company_id === company.id) {
							editCompany({ driver_recognition: changedData.driver_recognition })
						}
						editCompanyCollection({ id: company.id, driver_recognition: changedData.driver_recognition })
					}
					setUpd(!upd);
					toggleLoader(false);
					toastr.success('', 'Company was changed');
				})
				.catch((error) => {
					toggleLoader(false)
					console.log('!CompanyEditContainer updateCompany error: ', error.response, error)
					let errDescription = ''
					if (error.response.data.body) {
						errDescription = errorDetection(error.response.data.body) || error.response.data.body
					}
					toastr.error(`An unexpected error occurred. ${errDescription || 'Please try again later'}`);
				})
		}
	}

	const checkForm = (dataForm) => {
		let error = false;
		const updatedErrMessage = { ...errMessage };
		for (let i in dataForm) {
			if (dataForm[i] == '' && i !== 'company_phone_number' && i !== 'company_address2') {
				error = true;
				updatedErrMessage[i] = 'Enter your ' + i + '!';
			} else if (updatedErrMessage[i]) {
				updatedErrMessage[i] = null;
			}
		}

		if (dataForm.geotab_email && !updatedErrMessage.geotab_email) {
			const re = /^([a-zA-Z0-9_\-\.\+]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!re.test(dataForm.geotab_email)) {
				error = true;
				updatedErrMessage.geotab_email = 'Email is not valid.';
			}
		}

		if (!errMessage.data_threshold_pct && data.data_threshold_type === 'company' && dataForm.data_threshold_pct < 100) {
			error = true;
			updatedErrMessage.data_threshold_pct = 'Enter a value at least 100'
		}

		setErrMessage(updatedErrMessage);
		if (error) {
			toastr.error('', 'Company form conatins wrong value')
		}
		return error;
	}

	const handleInputChange = (event) => {
		const { target } = event;
		const { name } = target;
		let value = target.type === 'checkbox' ? target.checked : target.value;

		if (name === 'download_files') {
			if (value) {
				value = 2 // all files
			} else {
				value = 1 // event files
			}
		}

		setData({ ...data, [name]: value })
	}

	const modalConfirm = (e, action) => {
		let title, content;
		switch (action) {
			case 'delete':
				title = 'Delete Company'
				content = `Are you sure you want to delete the company ${company.company_name}?`
				break
			case 'import':
				title = 'Import'
				content = 'Please Log In in RoscoLive 1.0 for import'
				break
			case 'geotab_email':
				title = 'Provision for Geotab'
				content = 'Enter E-mail of a user from the company with Geotab administrator account privilege'
				setData({ ...data, show_provisionlink: false, geotab_provider: '1', geotab_email: '' })
				break
			case 'geotab_relation':
				title = 'Remove Geotab Relation'
				content = `Are you sure you want to remove the relation between a RL2 company "${location.state.company.company_name}" and a Geotab fleet "${company.geotab_database}" ?`
				break
			default:
				break
		}

		setModal({ ...modal, show: true, title, content, type_action: action })
		setErrMessage({ ...errMessage, user_login: '', user_password: '' })
	}

	const closeModal = () => {
		setModal({ ...modal, error: false, show: false });
	}

	const deleteCompanyModal = () => {
		const { delCompany } = props
		const data = {
			company_name: company.company_name,
			partner_name: location.state.company.owner_company,
			user_role: userRole,
		}

		deleteCompany(data)
			.then((res, err) => {
				if (res.status === 200) {
					setModal({ ...modal, show: false })
					toastr.success('', 'A company successfully deleted');

					if (data.partner_name === props.company.partner) {
						delCompany({ company: data.company_name });
					}

					browserHistory.push('/company');
				}
			})
			.catch((error) => {
				setModal({ ...modal, show: false })
				toastr.error('An unexpected error occurred. Please try again later');
			});
	}

	const deleteGeotabRelationModal = () => {
		let data = {
			company_name: company.company_name,
			partner_name: location.state.company.owner_company,
			user_role: user.roles[0],
			company_id: company.id
		}

		toggleLoader(true);

		getCompanyGeotabData(data)
			.then(async (resGeotab, errGeotab) => {
				console.log('!getCompanyGeotabData res: ', resGeotab, errGeotab);

				if (errGeotab) {
					toggleLoader(false);
					console.log('!getCompanyGeotabData err: ', errGeotab);
					toastr.error('An unexpected error occurred. Please try again later');
					return;
				}

				if (resGeotab.status === 200) {
					const geotab_company = resGeotab.data.response

					// REMOVES GEOTAB ADDINs
					// FWSD-4475
					let initData = {
						company_id: company.id,
						password: geotab_company.password,
						path: geotab_company.path,
						fleet_token: geotab_company.token,
						database: geotab_company.database,
						email: geotab_company.email,
						sessionId: geotab_company.session_id,
					}

					const resultAuth = await geotabAuthentication(initData)
					console.log('resultAuth!!!', resultAuth)
					if (resultAuth.error) {
						toggleLoader(false);
						toastr.error('An unexpected error occurred. Please try again later');
						return;
					}
					const { geotabApi, geotabData } = resultAuth
					data.path = geotabData.path
					data.database = geotabData.database
					data.sessionId = geotabData.sessionId


					// const api = new API(geotab_company.email, geotab_company.password, geotab_company.database, geotab_company.path)
					// api.authenticate((errAuth, resAuth) => {
					// 	console.log('!Authenticate res', resAuth, errAuth);

					// if (errAuth) {
					// 	toggleLoader(false);
					// 	console.log('!Authenticate error', errAuth);

					// 	toastr.error('An unexpected error occurred. Please try again later');
					// 	return;
					// }

					// if (resAuth.path && resAuth.credentials && resAuth.credentials.database) {
					// 	data.path = resAuth.path
					// 	data.database = resAuth.credentials.database
					// 	data.sessionId = resAuth.credentials.sessionId

					geotabApi.multicall([
						['Get', {
							typeName: 'SystemSettings',
							credentials: {
								database: data.database,
								userName: data.email,
								sessionId: data.sessionId,
							},
						}]
					],
						(errCall, resCall) => {
							console.log('!GET Geotab Settings res: ', resCall, errCall)

							if (errCall) {
								toggleLoader(false);
								console.log('!GET SystemSettings error: ', errCall)

								toastr.error('An unexpected error occurred. Please try again later');
								return
							}

							let systemSettings = resCall[0][0]

							const tmp = systemSettings.customerPages.filter(addin => {
								return JSON.parse(addin).name !== 'RoscoLive';
							});

							systemSettings.customerPages = tmp

							geotabApi.multicall([
								['Set', {
									typeName: 'SystemSettings',
									entity: systemSettings,
									credentials: {
										database: data.database,
										userName: data.email,
										sessionId: data.sessionId,
									},

								}]
							],
								(errSys, resSys) => {
									console.log('!SET SystemSettings res', resSys, errSys);

									if (errSys) {
										toggleLoader(false);
										console.log('!SET SystemSettings error', errSys)
										toastr.error('An unexpected error occurred. Please try again later');
										return
									}

									// DELETE GEOTAB RELATIONS
									deleteGeotabCompany(data)
										.then((res, err) => {
											console.log('!deleteGeotabCompany res:', res, err)

											if (err) {
												toggleLoader(false);
												console.log('!deleteGeotabCompany err', err);
												toastr.error('An unexpected error occurred. Please try again later');
												return
											}

											getCompany(company.id)

											setModal({ ...modal, show: false })
											toastr.success('', 'A geotab relation successfully deleted')
										})
										.catch((error) => {
											toggleLoader(false);
											console.log('!error', error.response.data.response.error);
											console.log(error.response);

											setModal({ ...modal, show: false })
											toastr.error('An unexpected error occurred. Please try again later');
										});

								},
								(a, p) => {
									toggleLoader(false);
									console.log('!SET SystemSettings1 a p: ', a, p);
									toastr.error('An unexpected error occurred. Please try again later');
								}
							);

						});
					// } else {
					// 	toggleLoader(false);
					// 	toastr.error('An unexpected error occurred. Please try again later');

					// 	return;
					// }
					// })
				}

			})
			.catch((error) => {
				toggleLoader(false);
				// NO GEOTAB COMPANY
				console.log('!getCompanyGeotabData error: ', error.response, error);
			});
	}

	const sendEmail = (e) => {
		e.preventDefault()

		const requestData = {
			geotab_email: data.geotab_email || '',
			company_name: company.company_name || '',
			partner_name: company.partner_company || '',
			provision_link: getProvisionLink()
		}
		const error = checkForm(requestData);
		if (!error) {
			toggleLoader(true)
			sendGeotabLink(data)
				.then((res, err) => {
					toggleLoader(false)
					console.log('!sendGeotabLink res', res, err)
					toastr.success("", "Email has been sent");
				})
				.catch((error) => {
					toggleLoader(false)
					console.log('!sendGeotabLink error', error)
					toastr.error('An unexpected error occurred. Please try again later');
				})
		}
	}

	const getProvisionLink = () => {
		const env = window.location.hostname;
		const typeAction = modal.type_action;
		const { geotab_provider, hash } = data;

		let domain = '';
		switch (env) {
			case 'localhost':
				domain = 'http://localhost:3000'
				break
			case 'test.roscocloud.com':
				domain = 'https://test.roscocloud.com'
				break
			case 'dev.roscocloud.com':
				domain = 'https://dev.roscocloud.com'
				break
			case 'staging.roscocloud.com':
				domain = 'https://staging.roscocloud.com'
				break
			case 'canada.roscolive.com':
				domain = 'https://canada.roscolive.com'
				break
			case 'roscocloud.com':
			case 'www.roscocloud.com':
			case 'fleet.roscolive.com':
				domain = 'https://roscocloud.com'
				break
			default:
				break
		}

		if (typeAction === 'webfleet_email') {
			return `${domain}/webfleet/credentials/${hash}`
		}

		return `${domain}/mygeotab/credentials/${geotab_provider}/${hash}`
	}

	const showProvisionLink = () => {
		setData({ ...data, show_provisionlink: true })
	}

	const copyProvisionlink = () => {
		const copyText = document.querySelector('#geotab-provision-link')
		copyText.select()
		document.execCommand("copy")
	}

	const {
		company_name,
		company_city,
		company_state,
		company_zipcode,
		company_address,
		company_country,
		billing_date,
		geotab_email,
		industry_type,
	} = errMessage;

	const industryTypeDisplayOptions = [
		'FTL/LTL/Courier',
		'Medical/Health',
		'School/Education',
		'Construction',
		'Waste Management',
		'Mass Transit',
		'Agricultural',
		'Government',
		'Industrial',
		'Other'
	];

	const industryTypeValueOptions = [
		'ftl_ltl_courier',
		'medical_health',
		'school_education',
		'construction',
		'waste_management',
		'mass_transit',
		'agricultural',
		'government',
		'industrial',
		'other'
	];

	if (!company) {
		return (
			<GreyHeader title="Edit Company" hideSubtitle />
		)
	}

	const headerOptions = {
		title: 'Edit Company',
		subtitle: location.state.company.company_name
	}

	return (
		<div className='edit-company'>
			<GreyHeader {...headerOptions} />
			<div className='page-subheader'>
				<div className='subheader-section company-info'>
					<CustomButton variant="primary" size="xs" onClick={() => redirectToRoscoLive('company', company.id)}>Go To Company</CustomButton>
					{(company.geotab_database || company.geotab_email)
					?
						<Dropdown
							drop
							id="geotab-dropdown"
							role="menuitem"
						>
							<Dropdown.Toggle as={CustomButtonToggle} variant='primary-outline' size="lg" disabled={userRole !== 'partner'}>
								Geotab Settings
							</Dropdown.Toggle>
							<Dropdown.Menu className="geotab-relations-menu">
								<div className='dropdown-body'>
									<h5 className='category-title'>Integration Info</h5>
									<div className='info-section'>
										<b>POC Email:</b> {company.geotab_email}
									</div>
									<div className='info-section'>
										{company.geotab_database && <div><b>Database:</b> {company.geotab_database}</div>}
									</div>
									<div className='info-section'>
										{company.geotab_path && <div><b>URL:</b> {company.geotab_path}</div>}
									</div>
									{company.geotab_database && <div>
										<h5 className='category-title'>Integration Credentials</h5>
										<div className='info-section'>
											<b>Email:</b> {geotab_creds.email}
										</div>
										<div className='info-section'>
											{showGeotabPassword ?
												<span><b>Password:</b> {geotab_creds.password}</span> :
												<CustomButton variant="link" onClick={() => setShowGeotabPassword(true)}>Show Password</CustomButton>
											}
										</div>
									</div>}
								</div>
								{!readOnly &&
								<div className='dropdown-footer'>
									<CustomButton variant="primary-outline" onClick={(e) => modalConfirm(e, 'geotab_email')}>Provision for Geotab</CustomButton>
									{company.geotab_database && (
										<CustomButton variant="delete" onClick={(e) => modalConfirm(e, 'geotab_relation')}>
											Delete Relation
										</CustomButton>
									)}
								</div>
								}
							</Dropdown.Menu>
						</Dropdown>
					:
						!readOnly && (
						<CustomButton
							variant="primary-outline"
							size="sm"
							id="geotab-dropdown"
							onClick={(e) => modalConfirm(e, 'geotab_email')}
						>
							Provision for Geotab
						</CustomButton>
						)
					}
				</div>

				<div className="subheader-section">
					{!readOnly &&
						<CustomButton variant="secondary" disabled={_.isEmpty(changeData())} onClick={saveCompanyUpdates}>SAVE</CustomButton>
					}
					<CustomButton variant="primary-outline" size="sm" onClick={cancelCompanyUpdates}>BACK</CustomButton>
				</div>
			</div>

			<main className='main-content-block'>
				<section>
					<h3 className="category-title">Company Info</h3>
					<div className="two-column-grid with-margin">
						<div className={classnames('two-columns', { 'has-error': company_name })}>
							<label className="control-label">Name:</label>
							<input
								type="text"
								name="company_name"
								className="vehicle-search"
								onChange={(e) => { handleInputChange(e) }}
								value={data.company_name || ""}
								maxLength={50}
								readOnly={readOnly}
							/>
							{company_name && <span className="help-block">{company_name}</span>}
						</div>

						<div className={classnames({ 'has-error': company_address })}>
							<label className="control-label">Address:</label>
							<input type="text" name="company_address" className="vehicle-search" onChange={handleInputChange} value={data.company_address || ""} readOnly={readOnly} />
							{company_address && <span className="help-block">{company_address}</span>}
						</div>

						<div className="optional">
							<label className="control-label">Address 2: <span>(optional)</span></label>
							<input type="text" name="company_address2" className="vehicle-search" onChange={handleInputChange} value={data.company_address2 || ""} readOnly={readOnly} />
						</div>

						<div className={classnames({ 'has-error': company_city })}>
							<label className="control-label">City:</label>
							<input type="text" name="company_city" className="vehicle-search" onChange={handleInputChange} value={data.company_city || ""} readOnly={readOnly} />
							{company_city && <span className="help-block">{company_city}</span>}
						</div>

						<div className={classnames({ 'has-error': company_state })}>
							<label className="control-label">State:</label>
							<input type="text" name="company_state" className="vehicle-search" onChange={handleInputChange} value={data.company_state || ""} readOnly={readOnly} />
							{company_state && <span className="help-block">{company_state}</span>}
						</div>

						<div className={classnames({ 'has-error': company_zipcode })}>
							<label className="control-label">Zip Code:</label>
							<input type="text" name="company_zipcode" className="vehicle-search" onChange={handleInputChange} value={data.company_zipcode || ""} readOnly={readOnly} />
							{company_zipcode && <span className="help-block">{company_zipcode}</span>}
						</div>

						<div className={classnames({ 'has-error': company_country })}>
							<label className="control-label">Country:</label>
							<input type="text" name="company_country" className="vehicle-search" onChange={handleInputChange} value={data.company_country || ""} readOnly={readOnly} />
							{company_country && <span className="help-block">{company_country}</span>}
						</div>

						<div className="optional">
							<label className="control-label">Phone Number: <span>(optional)</span></label>
							<input
								type="text"
								name="company_phone_number"
								className="vehicle-search"
								onChange={handleInputChange}
								value={data.company_phone_number || ""}
								readOnly={readOnly}
							/>
						</div>

						<div className={classnames({ 'has-error': billing_date })}>
							<label className="control-label">Billing Date:</label>
							<select
								placeholder="select"
								className="rosco-select block"
								name="billing_date"
								id="billing_date"
								onChange={handleInputChange}
								disabled
								value={data.billing_date ? data.billing_date : ''}
							>
								<option value="" />
								{_.range(1, 29).map((item, i) => (<option key={i} value={i + 1}>{item}</option>))}
							</select>
							{billing_date && <span className="help-block">{billing_date}</span>}
						</div>

						<div className={classnames({ 'has-error': industry_type })}>
							<label className="control-label">Industry Type:</label>
							<select
								placeholder="select"
								className="rosco-select block"
								name="industry_type"
								id="industry_type"
								onChange={(e) => { handleInputChange(e) }}
								value={data.industry_type ? data.industry_type : ''}
								disabled={readOnly}
							>
								<option value="" />
								{industryTypeDisplayOptions.map((item, i) => (
									<option key={i} value={industryTypeValueOptions[i]}>{item}</option>
								))}
							</select>
							{industry_type && <span className="help-block">{industry_type}</span>}
						</div>
					</div>
				</section>
			</main>

			<Modal
				show={modal.show}
				onHide={closeModal}
				className="modal-geotab"
			>
				<Modal.Header closeButton>
					<Modal.Title className={`${modal.type_action === 'delete' && 'delete-title'}`}>{modal.title}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{modal.type_action === 'geotab_email'
						&& (
							<div className="import-form">
								<div className="modal-text text-center">
									<p>{modal.content}</p>
								</div>
								<div>
									<div className="form-group">
										<label>Provider:</label>
										<div className="form-group">
											<select
												name="geotab_provider"
												className="rosco-select block"
												onChange={handleInputChange}
											>
												<option value="1">Geotab</option>
												<option value="2">SyncUp</option>
												<option value="3">GeotabPreview</option>
											</select>
										</div>
									</div>
									<div className={classnames('form-group', { 'has-error': geotab_email })}>
										<label>Email:</label>
										<input type="text" name="geotab_email" className="vehicle-search" onChange={handleInputChange} />
										{geotab_email && <span className="help-block">{geotab_email}</span>}
									</div>

									<div className='text-center button-wrapper'>
										<CustomButton
											variant="primary-outline"
											size="sm"
											onClick={showProvisionLink}
										>
											Generate Link
										</CustomButton>
										<CustomButton
											variant='primary'
											size="sm"
											type="submit"
											onClick={(e) => sendEmail(e, modal.type_action)}
										>
											Send Email
										</CustomButton>
									</div>

									{data.show_provisionlink
										&& (
											<div className="geotab-provision-link">
												<input type="text" id="geotab-provision-link" className='vehicle-search' value={getProvisionLink()} readOnly />
												<CustomButton
													size="icon"
													prefix="clipboard-btn"
													title="Copy Link"
													onClick={copyProvisionlink}
												>
													Copy
												</CustomButton>
											</div>
										)}
								</div>
							</div>
						)}
					{modal.type_action === 'delete' && <div className='modal-text'>{modal.content}</div>}
					{modal.type_action === 'geotab_relation' && <div>{modal.content}</div>}
				</Modal.Body>
				<Modal.Footer bsPrefix="default-modal-footer modal-footer">
					{modal.type_action === 'delete'
						&& (
							<CustomButton variant="delete" onClick={deleteCompanyModal}>Delete</CustomButton>
						)}
					{modal.type_action === 'geotab_relation'
						&& (
							<CustomButton variant="delete" onClick={deleteGeotabRelationModal}>Delete</CustomButton>
						)}
				</Modal.Footer>
			</Modal>
		</div>
	)
}

CompanyEditContainer.propTypes = {
	user: PropTypes.objectOf(PropTypes.any).isRequired,
	company: PropTypes.objectOf(PropTypes.any).isRequired
};

export default connect(
	state => ({
		user: state.user.user,
		company: state.company.company
	}),
	dispatch => ({
		delCompany: (company) => {
			dispatch({ type: 'DEL_COMPANY_SUCCESS', payload: company });
		},
		addCompany: (company) => {
			dispatch({ type: 'ADD_COMPANY_SUCCESS', payload: company });
		},
		editCompany: data => dispatch({ type: 'EDIT_COMPANY', payload: data }),
		editCompanyCollection: data => dispatch({ type: 'EDIT_COMPANY_COLLECTION', payload: data }),
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		},
	}),
)(CompanyEditContainer);
